import { Route } from '@angular/router';
import { HOME_PATH } from '../../../values/path';
import { FULL_ROUTES } from './components/layout/full-layout.routes';
import { CONTENT_ROUTE } from './components/layout/content-layout.route';
import { IsLoggedInGuard } from '../../../../sdk/src/lib/guards/is-logged-in.guard';
import { HasChangedInitialPasswordTherapist } from '../../../../sdk/src/lib/guards/has-changed-initial-password-therapist.guard';
import { IsUserWithTherapistPrivilegesGuard } from '../../../../sdk/src/lib/guards/is-user-with-therapist-privileges.guard';
import { AuthGuard } from '@auth0/auth0-angular';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: HOME_PATH,
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./components/layout/full-layout/full-layout.component').then(
        (fullLayoutModule) => fullLayoutModule.FullLayoutComponent
      ),
    children: FULL_ROUTES,
    canActivate: [
      IsLoggedInGuard,
      HasChangedInitialPasswordTherapist,
      IsUserWithTherapistPrivilegesGuard,
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import(
        './components/layout/content-layout/content-layout.component'
      ).then(
        (contentLayoutModule) => contentLayoutModule.ContentLayoutComponent
      ),
    children: CONTENT_ROUTE,
  },
];
